// extracted by mini-css-extract-plugin
export default {"timer-wrap":"Timer_timer-wrap__w+I-g","timer":"Timer_timer__7jUXB"};